import React from "react";
import { FormattedMessage } from "react-intl";

import { TextInput } from "@dzambalaorg/mui-inputs-core";
import { Alert, FormGrid } from "@dzambalaorg/ui-kit";

export const InviteDialog = () => {
  return (
    <FormGrid columns={[1, 1]}>
      <Alert severity="warning" sx={{ mt: 2 }}>
        <FormattedMessage id="alert.onlyIfUserExists" />
      </Alert>
      <TextInput name="email" type="email" />
    </FormGrid>
  );
};
